export const radioTheme = {
  baseStyle: {
    control: {
      backgroundColor: 'white',
      _checked: {
        _hover: {
          bg: 'transparent',
          borderColor: '#D7D8D9',
        },
        bg: 'transparent',
        borderColor: '#D7D8D9',
        borderWidth: '1px',
        backgroundColor: 'white',
        _before: {
          content: '""',
          display: 'block',
          position: 'relative',
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          bg: 'accentPrimary',
          margin: '5%',
        },
      },
      _focus: {
        boxShadow: 'none',
      },
      _active: {
        boxShadow: 'none',
      },
    },
  },
}
